import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { updateWholeCart } from '../../../store/actions/cartAction';
import { receivePickUpDate } from '../../../store/actions/pickupDateAction';
import { receiveError } from '../../../store/actions/notificationAction';

import PickUpDate from '../../pickUpDate/PickUpDate';
import GhaInfoContainer from '../../forwarderImport/ghaInfo/GhaInfoContainer';
import ForwarderHeaderInvoiceBalanceContainer from '../../forwarderHeaderInvoiceBalance/ForwarderHeaderInvoiceBalanceContainer';

import Cart from '../../../models/Cart';
import GhaModel from '../../../models/Gha';
import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';

import cartRemote from '../../../api/cartRemote';

import MomentUtils from "@date-io/moment";
import { Moment as MomentType } from 'moment';
import Moment from 'moment';

import cartStyles from '../cart.module.css';

interface CartHeaderProps {
  receivePickUpDate: Function;
  updateWholeCart: Function;
  receiveError: Function;
  ghaInfo: GhaModel;
  cart: Cart;
};

interface CartHeaderState {
  pickUpDate: MomentType;
};

class CartHeaderContainer extends Component<CartHeaderProps, CartHeaderState>  {

  state = {
    pickUpDate: new MomentUtils().date()
  }

  componentDidUpdate(prevProps: CartHeaderProps) {

    const newProps: CartHeaderProps = this.props;

    if (prevProps.cart !== newProps.cart) {
      const pickupDateInDateFormat: Date = Moment(this.props.cart.pickup_date, "YYYYMMDD").toDate();
      const dateToMoment: MomentType = new MomentUtils().date(pickupDateInDateFormat);

      this.setState({ pickUpDate: dateToMoment });

    };
  };

  handleChange = (date: MomentType): void => {
    
    this.setState({pickUpDate: date }, ()=> { this.handleUpdate()});
   
  };

  handleUpdate = (): void => {
    const puckUpDateFormated: string = Moment(this.state.pickUpDate).format('YYYYMMDD');

    cartRemote.changeCartPickupDate(puckUpDateFormated).then((resp: ApiResponse<Cart>) => {

      const cart: Cart | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (cart) {

        this.props.receivePickUpDate(this.state.pickUpDate);
        this.props.updateWholeCart(cart);
        this.setState({
          pickUpDate: this.state.pickUpDate
        });
      }
    
      if (error) {
        this.props.receiveError(error);
      }
    });
  };

  render() {
    let ghaId: number = -1;
    const cartItems: number = this.props.cart.items.length;

    if (cartItems > 0 && this.props.cart.items[0].id_gha) {
      ghaId = this.props.cart.items[0].id_gha;
    };

    return (
      <Fragment>
        { cartItems > 0 && this.props.ghaInfo.name &&
          <PickUpDate
            titleText={ 'Schedule Pick Up Date:' }
            pickUpDate={ this.state.pickUpDate }
            minDate={new Date(new Date().toLocaleString("en-US", {timeZone: this.props.ghaInfo.info.tz}))}
            handleChange={ this.handleChange }
          /> 
        }
        <div className={ cartStyles.forwarderWrap }>
          <ForwarderHeaderInvoiceBalanceContainer />
          <GhaInfoContainer ghaId={ ghaId } type={ 'import' } />
        </div>
      </Fragment>
    )
  };
};

const mapStateToProps = (state: any) => {
  return {
    cart: state.cart,
    ghaInfo: state.ghaInfo,
  };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
      receivePickUpDate: (pickUpDate: MomentType) => dispatch(receivePickUpDate(pickUpDate)),
      updateWholeCart: (cart: Cart) => dispatch(updateWholeCart(cart)),
      receiveError: (error: ResponseError) => dispatch(receiveError(error))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CartHeaderContainer);
